<template>    
    <!-- 下划线渲染
         @author: liuguisheng
         @date: 2019-11-25
    -->
    <div class="render-item"
        v-if="isDisplay"
        :style="{
            fontWeight: strong,
            lineHeight: lineHeight
        }"
        :class="{
            italic: italic == 'all',
            strong: strong == 'all',
        }">
        <!-- 标签 -->
        <div class="render-line">
            <span :class="{
                italic: italic == 'label',
                strong: strong == 'label'
            }">{{lineText}}</span>
            <!-- 线 -->
            <span class="line" :style="{borderStyle: lineStyle}"></span>
        </div>
    </div>
</template>


<script>
/** 混入方法 ::: 
 *  @mixin mixRenderItemTemplateChild 预览表单子级混入
 */
import { mixRenderItemTemplateChild } from "@/mixins/render_item/mix_render_item_template_child.js";


export default {
  mixins: [ mixRenderItemTemplateChild ]
}
</script>





// WEBPACK FOOTER //
// src/components/render_item/RenderReal.vue